/* eslint-disable import/prefer-default-export */

export const COMPANY_UPDATE = 'COMPANY_UPDATE';
export const COMPANY_LIST = 'COMPANY_LIST';
export const LOAD_COMPANY = 'LOAD_COMPANY';
export const SUBMIT_COMPANY = 'SUBMIT_COMPANY';
